import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getSchoolConfig } from '@/api/user/index.js'

export const useSchoolStore = defineStore('school', () => {
  const schoolId = ref(null)
  const schoolName = ref('')
  const schoolCode = ref('')        // dku / wku / self-register
  const loginType = ref('password') // password / sso_oauth2 / sso_saml / self_register
  const redeemEnabled = ref(false)
  const ssoEnabled = ref(false)
  const samlEnabled = ref(false)
  const selfRegister = ref(false)
  const emailDomain = ref('')
  const currentTermName = ref('')
  const currentYearName = ref('')
  /** 是否已成功拉取过学校配置（避免整页跳转后丢失 redeem 开关） */
  const configLoaded = ref(false)

  const isRedeemRequired = computed(() => redeemEnabled.value)
  const isSsoSchool = computed(() => ssoEnabled.value || samlEnabled.value)
  const isSelfRegister = computed(() => selfRegister.value)

  const setSchoolConfig = (config) => {
    schoolId.value = config.schoolId || null
    schoolName.value = config.schoolName || ''
    schoolCode.value = config.schoolCode || ''
    loginType.value = config.loginType || 'password'
    redeemEnabled.value = !!config.redeemEnabled
    ssoEnabled.value = !!config.ssoEnabled
    samlEnabled.value = !!config.samlEnabled
    selfRegister.value = !!config.selfRegister
    emailDomain.value = config.emailDomain || ''
    currentTermName.value = config.currentTermName || ''
    currentYearName.value = config.currentYearName || ''
    configLoaded.value = true
  }

  const clearSchoolConfig = () => {
    schoolId.value = null
    schoolName.value = ''
    schoolCode.value = ''
    loginType.value = 'password'
    redeemEnabled.value = false
    ssoEnabled.value = false
    samlEnabled.value = false
    selfRegister.value = false
    emailDomain.value = ''
    currentTermName.value = ''
    currentYearName.value = ''
    configLoaded.value = false
  }

  /**
   * 拉取当前用户学校配置（含 redeemEnabled 等）
   * 供登录、SSO 回调后冷启动、路由守卫共用
   *
   * 后端 t_school_config 表已处理所有学校的配置，前端不再硬编码 schoolId=1
   */
  const fetchSchoolConfig = async () => {
    try {
      const schoolRes = await getSchoolConfig()
      if (schoolRes?.code === 200) {
        setSchoolConfig(schoolRes)
        return schoolRes
      }
    } catch (e) {
      // ignore — 不阻断登录/进首页
    }
    return null
  }

  return {
    schoolId,
    schoolName,
    schoolCode,
    loginType,
    redeemEnabled,
    ssoEnabled,
    samlEnabled,
    selfRegister,
    emailDomain,
    currentTermName,
    currentYearName,
    configLoaded,
    isRedeemRequired,
    isSsoSchool,
    isSelfRegister,
    setSchoolConfig,
    clearSchoolConfig,
    fetchSchoolConfig,
  }
})
